import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { SupportTicket } from '../../types/support-ticket';
import { KendoGridResult } from '../../types/KendoGridResult';

const SupportTicketEndpoint = `supports`;

export const useGetSupportTickets = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<SupportTicket>
  >(`${SupportTicketEndpoint}?${params}`, GetAllAsync, options);

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};
